/* Copyright (C) 2018-2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

export default interface TAB_MENU
{
	MODULE_NAME                   : string;
	DISPLAY_NAME                  : string;
	RELATIVE_PATH                 : string;
	EDIT_ACLACCESS                : number;
	EDIT_LABEL                    : string;
}

